export default class Evaluation {
  /**
   * dataはnullも許容する
   *
   * @param {any|null} data
   */
  constructor(data) {
    this.id = data?.id;
    this.comment = data?.comment;

    /**
     * skillIdをkeyとする連想配列
     * @type {Object}
     */
    this.scores = data?.scores ? data.scores : {};

    // スキル別コメント
    this.comments = data?.comments ? data.comments : {};

    this.status = data?.status;

    this.totalScore = data?.total_score ? Math.round(data.total_score * 100) / 100 : null;

    this.totalMaxScore = data?.total_max_score;
  }

  /**
   * 確定済かどうか
   *
   * @returns {boolean}
   */
  isClosed() {
    return this.status === 'CLOSED'
  }

  /**
   * @param {number} skillId
   * @returns {number|null}
   */
  getScoreBySkillId(skillId) {
   return this.scores?.hasOwnProperty(skillId) ? this.scores[skillId] : null;
  }

  /**
   * 指定のEvaluationへデータをコピーする
   * コメントとスコアのみコピーする
   *
   * @param {Evaluation} dst
   */
  copy(dst, copyComment = false) {
    dst.scores = {...this.scores};
    dst.comments = {...this.comments};
    if (copyComment) {
      dst.comment = this.comment;
    }
  }
}
